module.exports = __webpack_public_path__ + "static/media/hallon_223156.a493e88e.png";